export class LoginModel {
    username: string = '';
    password: string = '';

    public isIncomplete() : boolean {
        return this.empty(this.username) || this.empty(this.password);
    }

    private empty(value: string) : boolean {
        return value == '' || value == null || value == undefined;
    }
}